import React, {useEffect} from 'react'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';

import FormFooter from '../common/FormFooter';
import Spinner from '../common/Spinner';

import useScrollTop from '../../hooks/useScrollTop';
import {useDataProviderState, useDataProviderActions} from '../../providers/DataProvider';
import HighlightBox from "../common/HighlightBox.jsx";
import {TrackGoogleAnalyticsEvent} from "../../google-analytics/gaTracker.js";

export default function IdVerificationNoticeStep() {

    const {userData, loading} = useDataProviderState();
    const {nextStep} = useDataProviderActions();

    useScrollTop();

    TrackGoogleAnalyticsEvent("IdVerificationNoticeStep");

    return (
        <Container component="section" maxWidth="sm">
            <Box sx={{pb: 2}}>
                <HighlightBox>
                    <Box sx={{display: 'flex'}}>
                        <Box sx={{py: 2}}>
                            <Box className="color-primary" sx={{pl: 3, pr: 3, pb: 1, fontSize: '1.3rem'}}>
                                <b>{userData.nombre},</b>
                            </Box>
                            <Box as="span" sx={{
                                display: 'inline-block',
                                px: 2,
                                color: 'white',
                                background: 'var(--color-primary)',
                                borderBottomRightRadius: '15px',
                                borderTopRightRadius: '15px',
                                fontSize: '1.2rem'
                            }}>
                                ¡Se está procesando tu préstamo!
                            </Box>
                            <Box sx={{p: 1, pl: 2}}>
                                <b className="msg">Es el momento de validar tu identidad.</b>
                            </Box>
                        </Box>
                    </Box>
                </HighlightBox>
            </Box>

            <Grid container spacing={{xs: 0, sm: 2}} alignItems="center" justifyContent="center">
                <Grid item sm={7} xs={12} sx={{pb: 0}} alignItems="center" justifyContent="center">
                    <Grid item sm={12} xs={12} sx={{pb: 3}}>
                        <ul className="checklist">
                            <li className="checklist__title">Preparate porque vas a precisar:</li>
                            <li className="checklist__item">Acceso a la cámara de tu celular</li>
                            <li className="checklist__item">Cédula de identidad</li>
                            <li className="checklist__item">Último recibo de sueldo</li>
                            <li className="checklist__item">Constancia de domicilio</li>
                        </ul>
                    </Grid>
                </Grid>
            </Grid>

            <FormFooter
                hideBackButton
                nextButtonLabel="¡Avanzamos al paso final!"
                onNext={nextStep}
            />

            <Spinner loading={loading}/>

        </Container>
    )

}
